import React from 'react';
import Slider from './Slider'
import TopHighlight from './TopHighlight';
import YouTubeEmbed from './YouTubeEmbed';
import Cult_slider from './Cult_slider';
import './Home.css';
import Work_slider from './Work_slider';
import img4 from './photos/grid1.jpeg'
import img5 from './photos/grid2.jpg'
import img6 from './photos/grid3.jpg'
import Footer from './Footer';
import { Fade } from "react-awesome-reveal";
import img1 from './photos/him-chatterjee.jpg'
import SafFound from './SafFound';
import Photogallery from './Photogallery';
import InstaPost from './InstaPost';
import MediaSection from './MediaSection';
import NewUpdates from './NewUpdates';

function Home() {
    return (
        <>
        <TopHighlight />
            <YouTubeEmbed />
            <div className="fest_outer">
                <Fade direction="down" triggerOnce={false} >
                    <h1 className='fest_head'>HIM CHATTERJEE</h1>
                </Fade>
                <div className="fest_inner">
                    <Fade direction="left" triggerOnce={false} >
                        <div className="fest_inner1">
                            <img src={img1} alt="" className='fest_pic1' />
                        </div>
                    </Fade>

                    <Fade direction="right" triggerOnce={false} >
                        <div className="fest_inner2">
                            <h2>For some people, life and colours are almost synonymous. They fill colour in life and instill life in colour. Him Chatterjee, is one such person. He is a Vice-Chancellor of Sir J. J. School of Art, Architecture & Design, Mumbai. Him is known for his master strokes with brush and colours. These are to be seen to be believed. Give him a piece of canvas and a brush, and it will burst into colours; give him pen or pencil and a sketch will materialize as if from nowhere; give him Charcoal and paper and see the wonder of his drawings.</h2>
                        </div>
                    </Fade>
                </div>
            </div>

            <Slider />
            <div className="home-content">
                <div className="box-content">
                     <Fade direction="left" triggerOnce={false} >
                        <div className="box1">PAINTINGS</div>
                        <div className="box1">DRAWINGS</div>
                        <div className="box1">MURALS</div>
                        <div className="box1">PUBLIC ART WORK</div>
                    </Fade>
                    <Fade direction="down" triggerOnce={false} >
                        <div className="box1">MISCELLANEOUS ART WORKS</div>
                    </Fade>
                     <Fade direction="right" triggerOnce={false} >
                        <div className="box1">SAF ART GALLERY</div>
                        <div className="box1">CONTE DRAWINGS</div>
                        <div className="box1">STRUCTURES</div>
                        <div className="box1">SCULPTURE</div>
                    </Fade>
                </div>
                <Fade direction="left" triggerOnce={false} >
                    <div className="text-content"><h2>Discover <span>art you love</span> from the world's <br /> LONGEST PAINTER</h2></div>
                </Fade>
            </div>
            <Cult_slider />

            <MediaSection />
            <NewUpdates />
            <Work_slider />

            <Fade direction="down" triggerOnce={false} >
                <div className="grid_para">
                    <Fade direction="right" duration={1500} triggerOnce>
                        <h1 className='grid_head'>ARTISTIC ODYSSEY</h1>
                    </Fade>

                    <div className="grid">

                        <div className="grid_pic1">
                            <img src={img4} />
                            <div className="h_d"><h1>MURALS</h1></div>
                        </div>
                        <div className="grid_pic2">
                            <div className="grid_pic2_1">
                                <img src={img5} />
                                <div className="h_d"><h1>HIMACHAL PRADESH CULTURE </h1></div>
                            </div>
                            <div className="grid_pic2_2">
                                <img src={img6} />
                                <div className="h_d"><h1>PAINTINGS</h1></div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
            <InstaPost />
            <Photogallery />
            < SafFound />
            <Footer />
        </>
    );
}

export default Home;